// Minimal shim for async_hooks used in some node-builtins imports
// Web builds don't need async_hooks; export a no-op stub.
module.exports = {};
